module.exports = __webpack_public_path__ + "img/4.b5d8c8c2.png";